module.exports = __webpack_public_path__ + "img/diente37.40f50392.png";